import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8aa17886"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-max-content col-lg-3" }
const _hoisted_2 = { class: "col-lg-4" }
const _hoisted_3 = { class: "w-max-content col-lg-3" }
const _hoisted_4 = { class: "col-lg-5" }

import { computed, withDefaults } from 'vue'
import { YELLOOP_CHECK_REJOIN_INTENTION_VALUES, YELLOOP_CHECK_REJOIN_DESIRED_INFORMATION_VALUES } from '@/constants/index'
import { translate } from '@/languages/i18n'

// 1. Define Props params
interface Props {
  rejoinIntention?: number
  desiredInformation?: number
  is_waiting_approval?: boolean
}


export default /*#__PURE__*/_defineComponent({
  props: {
    rejoinIntention: { default: undefined },
    desiredInformation: { default: undefined },
    is_waiting_approval: { default: false }
  },
  setup(__props: any) {

const props = __props as { rejoinIntention: number, desiredInformation: number, is_waiting_approval: boolean }



const rejoinIntentionName = computed(() => {
  return YELLOOP_CHECK_REJOIN_INTENTION_VALUES[props.rejoinIntention] ?? ''
})

const desiredInformationName = computed(() => {
  return YELLOOP_CHECK_REJOIN_DESIRED_INFORMATION_VALUES[props.desiredInformation] ?? ''
})

const classes = computed(() => {
  if (props.is_waiting_approval) {
    return {
      rejoin_intention: 'row ms-2 px-0 pb-4 gx-3 my-4 fs-7',
      desired_information: 'row ms-2 px-0 pb-4 gx-3 mb-4 fs-7',
      titile: 'fw-bold fs-6 p-3 text-lg-start',
    }
  }
  return {
    rejoin_intention: 'border-bottom row mx-0 px-0 pb-4 gx-3 my-4',
    desired_information: 'border-bottom row mx-0 px-0 pb-4 gx-3 mb-4',
    titile: 'fw-bold fs-6 p-2 text-lg-start',
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h3", {
      class: _normalizeClass(_unref(classes).titile)
    }, _toDisplayString(_unref(translate)('SA20YelloopCheckTitle')), 3),
    _createElementVNode("div", {
      class: _normalizeClass(_unref(classes).rejoin_intention)
    }, [
      _createElementVNode("label", _hoisted_1, _toDisplayString(_unref(translate)('SA20YelloopCheckRejoinIntentionLabel')), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(rejoinIntentionName)), 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_unref(classes).desired_information)
    }, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(translate)('SA20YelloopCheckDesiredInformationLabel')), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(desiredInformationName)), 1)
    ], 2)
  ]))
}
}

})